import { Dropdown } from "@freightsimple/ui-core/Controls/Dropdown";
import {
  FormItem,
  type ErrorMessageType,
} from "@freightsimple/ui-core/FormLayout/FormItem";
import { ShowFormErrors } from "@freightsimple/ui-core/FormLayout/ShowFormErrors";

interface TarpingRequiredDropdownProps {
  value: boolean | undefined;
  onChange: (newValue: boolean | undefined) => void;
  enabled: boolean;
  errorMessage?: ErrorMessageType | undefined;
  forceValidation?: boolean | undefined;
}

const options = [
  { value: "false", label: "Tarp Not Required" },
  { value: "true", label: "Tarp Required" },
];

export function BookShipmentTarpingRequiredDropdown(
  props: TarpingRequiredDropdownProps,
) {
  return (
    <ShowFormErrors show={props.forceValidation ?? false}>
      <FormItem error={props.errorMessage} fillWidth>
        <Dropdown
          value={props.value === undefined ? undefined : String(props.value)}
          onChange={(v) => props.onChange(v === "true")}
          options={options}
          placeholder="Select Tarp Preference"
          disabled={!props.enabled}
          width="full"
        />
      </FormItem>
    </ShowFormErrors>
  );
}
